const NotificationHelper = {

    formatObject(customerAccountData, selectedServiceAccountArray, strings, stateData, preferenceDataArr,dropDownDataArr) {
        var contactTypeArr = ['email', 'voice', 'text'], contactList = [];
        contactTypeArr.map((contactType) => {
            stateData.addContactCheckedStatusArr[contactType].map((checkedStatusFlag, index) => {
                preferenceDataArr.map((preferenceData)=>{
                    let contactArr = this.getModifiedContact(stateData, contactType, index, checkedStatusFlag, dropDownDataArr[0],preferenceData);
                    contactList.push(...contactArr);
                });
            });
        });
        contactTypeArr.map((contactType) => {
            preferenceDataArr.map((preferenceData)=>{
                preferenceData.addContactCheckedStatusArr[contactType].map((checkedStatusFlag, index) => {
                    let contact = this.getModifiedContactForRemove(stateData, contactType, index, preferenceData);
                    if(contact.action!=='' && contactList.indexOf(contact) === -1) contactList.push(contact);
                });
            });
        });
        let deviceEnrollmentVar = [], deviceDeEnrollmentVar=[],existingDeviceArr=[], enrollmentObject = {}, enrollmentArray = [];
        contactList.map((contact) => {
            if(contact.action === 'I') deviceEnrollmentVar.push(contact);
            else if(contact.action === 'E') deviceDeEnrollmentVar.push(contact);
            else if(contact.action === 'A') existingDeviceArr.push(contact);
        });
        deviceEnrollmentVar = this.getUniqueDeviceEnrollmentVar(deviceEnrollmentVar);
        deviceEnrollmentVar = this.getFilteredDeviceEnrollmentVar(deviceEnrollmentVar, existingDeviceArr);
        enrollmentObject = {
            deviceEnrollmentList: deviceEnrollmentVar,
            deviceDeEnrollmentList: deviceDeEnrollmentVar,
            existingDeviceArr: deviceEnrollmentVar.length===0 && deviceDeEnrollmentVar.length===0 ? existingDeviceArr : [],
            customerAccountNumber: "",
        };
        enrollmentArray.push(enrollmentObject);
        let requestArrays = {};
        requestArrays = {
            enrollmentArray: enrollmentArray,
        };
        return requestArrays;
    },
    getModifiedContact(stateData, contactType, index, checkedStatusFlag, preferenceData,actualPref) {
        preferenceData = this.insertActualPrefToPreferenceData(preferenceData, actualPref);
        var selectedValue = contactType==="email" ? stateData.addContactValueArr[contactType][index] : stateData.addContactEncValueArr[contactType][index];
        if(selectedValue === '') return {};
        var fieldKeys = { 'email': 'emailSet', 'text': 'mobileSet', 'voice': 'phoneSet' };
        var channelKeys = { 'email': 'INT', 'text': 'PAG', 'voice': 'TEL' };
        var contactArr=[],returnArr = [];
        for (let p = 0; p < preferenceData[fieldKeys[contactType]].length; p++) {
            var fieldNames = { 'email': 'email', 'text': 'encryptedPhoneNumber', 'voice': 'encryptedPhoneNumber' };
            if (selectedValue === preferenceData[fieldKeys[contactType]][p][fieldNames[contactType]]) {
                var contact = {
                    action: '',
                    contactType: contactType,
                    value: selectedValue,
                    channel: channelKeys[contactType],
                    objectKey: actualPref.premiseNumber,
                    removeFromDate: '',
                };
                var record_guid = preferenceData[fieldKeys[contactType]][p].record_guid;
                var objectKey = preferenceData[fieldKeys[contactType]][p].objectKey;
                if(record_guid && record_guid !== 'NEW' && !checkedStatusFlag && actualPref.premiseNumber === objectKey) contact.action = 'E';
                else if(record_guid && record_guid !== 'NEW' && checkedStatusFlag){
                    contact.action = actualPref.premiseNumber === objectKey ? 'A' : 'I';
                }
                else if(record_guid === 'NEW' && checkedStatusFlag) contact.action = 'I';
                if(contact.action === 'E') {
                    contact.record_guid = preferenceData[fieldKeys[contactType]][p].record_guid;
                    contact.objectKey = preferenceData[fieldKeys[contactType]][p].objectKey || '';
                    contact.removeFromDate = preferenceData[fieldKeys[contactType]][p].removeFromDate;
                }
                contact.value = contact.value;
                contact.action!=='' ? contactArr.push(contact) : null;
            }
        }
        contactArr.map((contact)=>{
            returnArr.indexOf(contact)===-1 ? returnArr.push(contact) : null;
        });
        return returnArr;
    },
    getModifiedContactForRemove(stateData, contactType, index, preferenceData){
        var selectedValue = contactType==="email" ? preferenceData.addContactValueArr[contactType][index] : preferenceData.addContactEncValueArr[contactType][index];
        if(selectedValue === '') return {action:""};
        var fieldKeys = { 'email': 'emailSet', 'text': 'mobileSet', 'voice': 'phoneSet' };
        var channelKeys = { 'email': 'INT', 'text': 'PAG', 'voice': 'TEL' };
        var fieldNames = { 'email': 'email', 'text': 'encryptedPhoneNumber', 'voice': 'encryptedPhoneNumber' };
        var contact = {
            action: '',
            contactType: contactType,
            value: selectedValue,
            channel: channelKeys[contactType],
            objectKey: '',
            removeFromDate: '',
        };
        var addContactValueArr = contactType==="email" ? stateData.addContactValueArr[contactType] : stateData.addContactEncValueArr[contactType];
        var indexTwo = addContactValueArr.indexOf(selectedValue);
        if( indexTwo===-1){
            var keySet = preferenceData[fieldKeys[contactType]].filter((detail)=>{
                return detail[fieldNames[contactType]]===selectedValue && detail.objectKey===preferenceData.premiseNumber;
            });
            contact.action = 'E';
            contact.objectKey = keySet[0].objectKey || '';
            contact.record_guid = keySet[0].record_guid || '';
            contact.removeFromDate = keySet[0].removeFromDate || '';
            contact.value = contact.value;
        }
        return contact;
    },
    getUniqueDeviceEnrollmentVar(deviceEnrollmentVar){
        let returnArr = [], returnIndexArr = [];
        for(var d=0;d<deviceEnrollmentVar.length;d++){
            if(returnIndexArr.indexOf(d)===-1){
                for(var f=0;f<deviceEnrollmentVar.length;f++){
                    let objectKeyFlag = deviceEnrollmentVar[d].objectKey === deviceEnrollmentVar[f].objectKey;
                    let channelFlag = deviceEnrollmentVar[d].channel === deviceEnrollmentVar[f].channel;
                    let valueFlag = deviceEnrollmentVar[d].value === deviceEnrollmentVar[f].value;
                    if(objectKeyFlag && channelFlag && valueFlag && d!==f) returnIndexArr.push(f);
                }
            }
        }
        returnArr = deviceEnrollmentVar.filter((device, ind)=>returnIndexArr.indexOf(ind)===-1);
        return returnArr;
    },
    getFilteredDeviceEnrollmentVar(deviceEnrollmentVar, existingDeviceArr){
        let returnArr = [], returnIndexArr = [];
        for(var d=0;d<deviceEnrollmentVar.length;d++){
            for(var existingDevice of existingDeviceArr){
                let objectKeyFlag = deviceEnrollmentVar[d].objectKey === existingDevice.objectKey;
                let channelFlag = deviceEnrollmentVar[d].channel === existingDevice.channel;
                let valueFlag = deviceEnrollmentVar[d].value === existingDevice.value;
                if(objectKeyFlag && channelFlag && valueFlag) returnIndexArr.push(d);
            }
        }
        returnArr = deviceEnrollmentVar.filter((device, ind)=>returnIndexArr.indexOf(ind)===-1);
        return returnArr;
    },
    getDefaultAccordianToggleStatusData(accordianToggleStatus, addContactLimitArr){
        let obj = {...accordianToggleStatus};
        for(var key in addContactLimitArr){
            if(addContactLimitArr[key]>0) obj[key] = true;
        }
        return obj;
    },
    getDefaultErrorStateData(updatedState) {
        var obj = { ...updatedState };
        obj.isAddContactDropDownSelectError = { 'email': false, 'voice': false, 'text': false };
        obj.isDropDownSelectError = { 'email': [false, false, false], 'voice': [false, false, false], 'text': [false, false, false] };
        obj.isSameValueSelectError = { 'email': [false, false, false], 'voice': [false, false, false], 'text': [false, false, false] };
        obj.isAnyCheckBoxCheckedFlag = true;
        obj.isSamePreferenceSaved = {contactType: '', isError:false};
        return obj;
    },
    formatPhoneNumWithStar(phoneNumber){
        var phoneNum = phoneNumber.replace(/-/g, "");
        return phoneNum[0]==='*' ? phoneNum.slice(0,3)+'-'+phoneNum.slice(3,6)+'-'+phoneNum.slice(6) : '***-***-'+phoneNum.slice(6);
    },
    formatEmailIdWithStar(emailId){
        return  emailId.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c);
    },
    insertActualPrefToPreferenceData(preferenceData, actualPref) {        
       if(!_.isEmpty(actualPref.emailSet)) {
        _.each(actualPref.emailSet, function(actualPrefEmail){
            _.each(preferenceData.emailSet, function(preferenceDataEmail, index){
                preferenceDataEmail.email === actualPrefEmail.email ? preferenceData.emailSet[index] = {...actualPrefEmail} : null;
            });
        });
       }
       if(!_.isEmpty(actualPref.phoneSet)) {
        _.each(actualPref.phoneSet, function(actualPrefPhone){
            _.each(preferenceData.phoneSet, function(preferenceDataEmail, index){
                preferenceDataEmail.encryptedPhoneNumber === actualPrefPhone.encryptedPhoneNumber ? preferenceData.phoneSet[index] = {...actualPrefPhone} : null;
            });
        });
       }
       if(!_.isEmpty(actualPref.mobileSet)) {
        _.each(actualPref.mobileSet, function(actualPrefMobile){
            _.each(preferenceData.mobileSet, function(preferenceDataEmail, index){
                preferenceDataEmail.encryptedPhoneNumber === actualPrefMobile.encryptedPhoneNumber ? preferenceData.mobileSet[index] = {...actualPrefMobile} : null;
            });
        });
       }
        return preferenceData;
    }
};

export default NotificationHelper;
